import { HttpClient } from '@angular/common/http';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { map, Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { customPackagePayload, customPackagesResponse, filterPayloads, packageResponse, packages, trendingPackageResponse, vacationPackagesResponse } from '../models/package.model';
import { categoryFilter, offferDealsResponseArray } from '../models/home.model';
import { CommonResponse } from '../models/common.model';

@Injectable({
  providedIn: 'root'
})
export class PackageService {
  constructor(
    private http: HttpClient,
    private _translateService: TranslateService,
    @Inject(PLATFORM_ID) private platformId: object
  ) {}

  getPackageData(query: string, filterPayload?: filterPayloads): Observable<packageResponse> {
    return this.http
      .post<{ data: packageResponse }>(`${environment.base_url}user/packages?${query}`, filterPayload)
      .pipe(map(res => res.data));
  }

  getPackageById(userId: string, queryString?: string): Observable<packages> {
    return this.http
      .post<{
        data: packages;
      }>(`${environment.base_url}user/packages/${userId}?${queryString}`, null)
      .pipe(map(res => res.data));
  }

  getBuyNowPackageById(userId: string): Observable<packages> {
    return this.http
      .get<{
        data: packages;
      }>(`${environment.base_url}user/checkout/${userId}`)
      .pipe(map(res => res.data));
  }

  getCustomPackageById(packageID: string, queryString?: string): Observable<packages> {
    return this.http
      .get<{
        data: packages;
      }>(`${environment.base_url}user/myCustomPackages/${packageID}?${queryString}`)
      .pipe(map(res => res.data));
  }

  getTrendingPackageData(query: string): Observable<trendingPackageResponse> {
    return this.http
      .get<{ data: trendingPackageResponse }>(`${environment.base_url}user/getAllTrendingDeals?${query}`)
      .pipe(map(res => res.data));
  }


  getOffersAndDeals(query: string): Observable<offferDealsResponseArray> {
    return this.http
      .get<{ data: offferDealsResponseArray }>(`${environment.base_url}user/getAllOfferAndDeals?${query}`)
      .pipe(map(res => res.data));
  }

  getAllVacationPackages(query: string): Observable<vacationPackagesResponse> {
    return this.http
      .get<{ data: vacationPackagesResponse }>(`${environment.base_url}user/getVocationalPackages?${query}`)
      .pipe(map(res => res.data));
  }

  getAllPackages(query: string, filterPayload?: filterPayloads): Observable<packageResponse> {
    return this.http
      .post<{ data: packageResponse }>(`${environment.base_url}user/packages?${query}`, filterPayload)
      .pipe(map(res => res.data));
  }

  addCustomPackage(payload: customPackagePayload): Observable<CommonResponse> {
    return this.http
      .post<{data:CommonResponse}>(`${environment.base_url}user/addCustomPackage`, payload)
      .pipe(map(res => res.data));
  }

  getCustomPackages(query: string): Observable<customPackagesResponse> {
    return this.http
      .get<{ data: customPackagesResponse }>(`${environment.base_url}user/myCustomPackages?${query}`)
      .pipe(map(res => res.data));
  }

  getAllCategories(): Observable<categoryFilter> {
    return this.http
      .get<{ data: categoryFilter }>(`${environment.base_url}user/categoryDropdown`)
      .pipe(map(res => res.data));
  }
}
